var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1905 16H3.80952V5.6L9.14286 0L10.0952 1C10.1841 1.09333 10.2571 1.22 10.3143 1.38C10.3714 1.54 10.4 1.69333 10.4 1.84V2.12L9.5619 5.6H14.4762C14.8825 5.6 15.2381 5.76 15.5429 6.08C15.8476 6.4 16 6.77333 16 7.2V8.8C16 8.89333 15.9873 8.99333 15.9619 9.1C15.9365 9.20667 15.9111 9.30667 15.8857 9.4L13.6 15.04C13.4857 15.3067 13.2952 15.5333 13.0286 15.72C12.7619 15.9067 12.4825 16 12.1905 16ZM5.33333 14.4H12.1905L14.4762 8.8V7.2H7.61905L8.64762 2.8L5.33333 6.28V14.4ZM3.80952 5.6V7.2H1.52381V14.4H3.80952V16H0V5.6H3.80952Z",
    fill: "#AB47BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.5fc57fc94408fe8cfaa44ee2bab5ce66.svg";
export { ForwardRef as ReactComponent };